(function(){
  /* Superficie de una unidad en m2. Las laminas de butilo (2 / 2,5 / 3 mm) miden
     46 x 80 cm = 0,368. La de 7 mm mide 50 x 80 = 0,40. Los termicos vienen en
     planchas de 1 m2. Cada plantilla lo declara con <span data-vp-area="...">.

     'siempre' fuerza a mostrar el precio por unidad aunque la variante traiga
     una sola: en los termicos es lo que deja ver que la plancha suelta sale mas
     cara por m2 que el rollo. */
  var BASE=0.368;
  var META={
    '1 lamina':{u:1,t:'para probar',un:'lámina'},
    'pack 5 laminas':{u:5,t:'cubre 2 puertas',un:'lámina'},
    'pack 10 + rodillo':{u:10,t:'cubre 4 puertas',un:'lámina'},
    'pack 10 laminas':{u:10,t:'cubre 4 puertas',un:'lámina'},
    'plancha 1 m²':{u:1,t:'100 × 100 cm',un:'m²',siempre:true},
    'rollo 5 m²':{u:5,t:'equivale a 5 planchas',un:'m²',siempre:true}
  };
  function area(){
    var el=document.querySelector('[data-vp-area]');
    var v=el?parseFloat(el.getAttribute('data-vp-area')):NaN;
    return isNaN(v)||v<=0?BASE:v;
  }
  function cobertura(u,t){return (u*area()).toFixed(2).replace('.',',')+' m² · '+t;}
  function norm(s){return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/\s+/g,' ').trim();}
  function money(c){return '$'+Math.round(c/100).toLocaleString('es-CL');}
  function esc(s){return String(s).replace(/[&<>"]/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m];});}

  function apply(){
    var s=document.querySelector('script[data-variants]');
    if(!s){return;}
    var vs;try{vs=JSON.parse(s.textContent);}catch(e){return;}
    var map={},best=0,bestKey='';
    vs.forEach(function(v){
      var k=norm(v.title),p=0;
      if(v.compare_at_price&&v.compare_at_price>v.price){
        p=Math.round((v.compare_at_price-v.price)*100/v.compare_at_price);
      }
      map[k]={v:v,pct:p};
      if(p>best){best=p;bestKey=k;}
    });
    document.querySelectorAll('.label-swatch').forEach(function(l){
      var k=norm(l.getAttribute('title')||l.textContent);
      var d=map[k];
      if(!d){return;}
      /* si el theme re-renderizo la label el flag se pierde -> se vuelve a pintar */
      if(l.dataset.vpCard===k){return;}
      var m=META[k]||{};
      var h='<span class="vp-radio"></span><span class="vp-info">';
      h+='<span class="vp-name">'+esc(d.v.title)+'</span>';
      if(m.u){h+='<span class="vp-cov">'+cobertura(m.u,m.t)+'</span>';}
      if(m.u&&(m.u>1||m.siempre)){h+='<span class="vp-unit">'+money(d.v.price/m.u)+' por '+m.un+'</span>';}
      h+='</span><span class="vp-price"><span class="vp-now">'+money(d.v.price)+'</span>';
      if(d.v.compare_at_price>d.v.price){h+='<span class="vp-was">'+money(d.v.compare_at_price)+'</span>';}
      h+='</span>';
      if(d.pct>0){h+='<span class="vp-save'+(k===bestKey?' vp-save--best':'')+'">AHORRA '+d.pct+'%</span>';}
      if(k===bestKey){h+='<span class="vp-best-tag">MEJOR VALOR</span>';}
      l.innerHTML=h;
      l.dataset.vpCard=k;
    });
  }

  /* El theme reemplaza el variant picker al elegir variante y borra las cards.
     Observamos el DOM y repintamos. Debounce con setTimeout, no rAF:
     rAF no corre si la pestana esta oculta y el repintado quedaria colgado. */
  var obs=null,queued=false;
  function pump(){
    if(queued){return;}
    queued=true;
    setTimeout(function(){
      queued=false;
      if(obs){obs.disconnect();}
      try{apply();}catch(e){}
      if(obs){obs.observe(document.body,{childList:true,subtree:true});}
    },0);
  }
  function init(){
    try{apply();}catch(e){}
    obs=new MutationObserver(pump);
    obs.observe(document.body,{childList:true,subtree:true});
    document.addEventListener('change',pump,true);
    document.addEventListener('click',function(){setTimeout(pump,60);},true);
    [300,900,2000].forEach(function(t){setTimeout(pump,t);});
  }
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
})();

/* El boton flotante de WhatsApp (fixed, bottom 30px, z-index 999999999) cae
   encima de la barra sticky de compra (z-index 20, ~137px de alto) y tapa el
   "Agregar al carrito". Lo subimos mientras la barra este visible y lo
   devolvemos a su sitio cuando no. */
(function(){
  var BTN_BASE=30,POP_BASE=102,HOLGURA=18;
  function card(){return document.querySelector('.product-sticky-form__card');}
  /* cuanto ocupa la barra desde el borde inferior, o 0 si esta oculta */
  function ocupa(){
    var c=card();
    if(!c){return 0;}
    var cs=getComputedStyle(c);
    if(cs.opacity==='0'||cs.visibility==='hidden'||cs.display==='none'){return 0;}
    var r=c.getBoundingClientRect();
    if(r.height<10){return 0;}
    var desdeAbajo=window.innerHeight-r.top;
    return desdeAbajo>10?Math.ceil(desdeAbajo):0;
  }
  function ajustar(){
    var btn=document.querySelector('.wa__btn_popup');
    if(!btn){return;}
    var pop=document.querySelector('.wa__popup_chat_box');
    var h=ocupa();
    btn.style.setProperty('bottom',(h?h+HOLGURA:BTN_BASE)+'px','important');
    if(pop){pop.style.setProperty('bottom',(h?h+HOLGURA+72:POP_BASE)+'px','important');}
  }
  var t=null,mo=null;
  function pedir(){
    if(!mo){
      var c=card();
      if(c&&window.MutationObserver){
        mo=new MutationObserver(pedir);
        mo.observe(c,{attributes:true,attributeFilter:['class','style']});
      }
    }
    if(t){return;}
    t=setTimeout(function(){t=null;try{ajustar();}catch(e){}},80);
  }
  if(document.readyState!=='loading'){pedir();}else{document.addEventListener('DOMContentLoaded',pedir);}
  window.addEventListener('scroll',pedir,{passive:true});
  window.addEventListener('resize',pedir);
  [400,1200,2500].forEach(function(d){setTimeout(pedir,d);});
})();
